"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapE = void 0;
var id_fn_1 = require("../functions/id-fn");
var map_each_1 = require("./map-each");
var mapE = function (mapFn) { return (0, map_each_1.mapEach)(id_fn_1.idfn, mapFn, id_fn_1.idfn); };
exports.mapE = mapE;
